import noop from 'lodash/noop'
import { createContext } from 'react'

import { Group, SplitTests } from '@Globals/SplitTests/types'

interface SplitTestsContextData {
  activateSplitTest: (test: string, group: Group) => void
  observeSplitTest: (test: string) => void
  splitTests: SplitTests
}

const defaultValue: SplitTestsContextData = {
  activateSplitTest: noop,
  observeSplitTest: noop,
  splitTests: {},
}

export const SplitTestsContext = createContext<SplitTestsContextData>(defaultValue)
export const SplitTestsProvider = SplitTestsContext.Provider
